export default "__VITE_ASSET__DN0sEv61__"